import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { posts } from "../data/blog";

const Blog = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28" data-testid="blog-page">
      <Helmet>
        <title>Блог — Ишеевские пироги | Рецепты и советы по выпечке</title>
        <meta name="description" content="Блог пекарни Ишеевские пироги. Рецепты домашней выпечки, советы по заказу пирогов в Ульяновске, истории из нашей пекарни с 1995 года." />
        <link rel="canonical" href="https://pirogi73.ru/blog/" />
        <meta property="og:title" content="Блог — Ишеевские пироги" />
        <meta property="og:description" content="Рецепты домашней выпечки и советы по заказу пирогов в Ульяновске." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pirogi73.ru/blog/" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://pirogi73.ru/#business",
          "name": "Ишеевские пироги",
          "telephone": "+79378764537",
          "url": "https://pirogi73.ru",
          "address": { "@type": "PostalAddress", "addressLocality": "Ульяновск", "addressRegion": "Ульяновская область", "addressCountry": "RU" },
          "areaServed": { "@type": "City", "name": "Ульяновск" },
          "openingHoursSpecification": { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "09:00", "closes": "21:00" }
        })}</script>
      </Helmet>
      <div className="label-eyebrow mb-4">Блог</div>
      <h1 className="font-display text-5xl sm:text-6xl text-[#2C2520] leading-tight mb-16">
        Рецепты и&nbsp;истории
        <br />
        из нашей пекарни
      </h1>

      <div className="space-y-6">
        {posts.map((post) => (
          <Link
            key={post.id}
            to={`/blog/${post.slug}`}
            className="group block bg-white border border-[#E8E3DA] rounded-[24px] overflow-hidden hover:border-[#C65D3B] transition-colors"
          >
            {post.image && (
              <div className="aspect-[3/1] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            )}
            <div className="p-8">
              <div className="label-eyebrow mb-3">{post.date}</div>
              <h2 className="font-display text-2xl text-[#2C2520] mb-3 group-hover:text-[#C65D3B] transition-colors">
                {post.title}
              </h2>
              <p className="text-[#5C4F45] leading-relaxed">{post.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;
